import Offcanvas from '../../../../../components/new_offcanvas/offcanvas_menu'

export default function (options){
    let offcanvas = new Offcanvas({
        id: options.id,
        title: "Controle de camadas",
        subtitle: "Informe as configurações da consulta",
        height: "offcanvas-hlg",
        width: "offcanvas-wmd",
        position:'right'
    })
    this.generate = () =>{
        offcanvas.generate()
        offcanvas.appendToBody("<div id='layer_control_container'></div>")
    }
    this.show = () =>{
        offcanvas.show()
    }
    this.hide = () =>{
        offcanvas.hide()
    }
}